import React from 'react'
import { useNavigate } from 'react-router-dom'
import { CButton, CCard, CCardBody, CCardText, CCardTitle } from '@coreui/react'

const EnDesarrolloPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <CCard className="text-center" style={{ maxWidth: 480, width: '100%' }}>
        <CCardBody className="p-5">
          <CCardTitle>Pendiente de réplica</CCardTitle>
          <CCardText>Este módulo de SiprinMax aún no tiene réplica en el backend. Se replicará en una próxima etapa.</CCardText>
          <CButton color="primary" onClick={() => navigate('/home')}>
            Volver al inicio
          </CButton>
        </CCardBody>
      </CCard>
    </div>
  )
}

export default EnDesarrolloPage
